<template>
  <div class="section">
    <div class="container fluid">
      <div ref="about" class="aboutSection">
        <div class="row">
          <div class="col-sm-6">
            <h2>ABOUT US</h2>
            <div class="separator"></div>
            <h3>
              Based in CDG<br />
              and
              <a href="https://www.bacs-oua.com/" target="_blank"
                >West Africa airports</a
              >
            </h3>
          </div>
          <div class="col-sm-6">
            <p class="text">
              BACS offers Air Cargo Solutions to Airlines and Forwarders:<br /><br />
              - GSA/GSSA<br />
              - CSA<br />
              - VIP flight and cargo assistance staff trained IATA<br />
              - Cargo Charters<br /><br />

              We provide online services: quotation, booking, track and trace
              and taylormade services for our customers Airlines and Forwarders
              and basic non virtual services.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script scoped>
export default {
};
</script>
<style scoped>
.section {
  background-image: url(../../assets/img/bgDark.png);
  position: relative;
}
.aboutSection {
  padding-top: 80px;
  padding-bottom: 80px;
}
a {
  color: #fff;
  text-decoration: none;
  border-bottom: 2px dashed #fff;
}
a:hover {
  color: #cd1a1b;
  border-bottom: 2px dashed #cd1a1b;
}
h2 {
  font-family: "Roboto", sans-serif;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  color: #fff;
}
h3 {
  font-family: "Roboto", sans-serif;
  font-size: 50px;
  font-weight: 900;
  text-align: center;
  line-height: 70px;
  color: #fff;
  margin-bottom: 50px;
}
.separator {
  margin-top: 40px;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  width: 80px;
  height: 9px;
  background-color: #cd1a1b;
}
.text {
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  font-weight: 500;
  padding: 0 20px 0 20px;
  text-align: left;
  color: #fff;
}
</style>